var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: "#25282D",
    "aria-labelledby": titleId,
    className: "ButtonIcon___style-module__thumbsdown___5o9gl",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.768 2.192a.847.847 0 0 0-.29.4.987.987 0 0 1-.045.13c-2.292 5.44-4.98 6.883-6.556 7.205-.466.096-.975.085-1.332.077-.086-.002-.163-.004-.228-.004H2v5a1 1 0 1 1-2 0V9.48C0 8.664.663 8 1.48 8h2.837c.158 0 .294.003.414.005.312.005.52.01.746-.037.748-.153 2.98-.993 5.09-5.97C10.888.952 11.97 0 13.25 0c1.18 0 2.114.579 2.643 1.467.51.856.608 1.927.343 2.94L15.296 8h5.018a3.687 3.687 0 0 1 3.067 5.732l-.049.073-.832-.555.832.555A1.977 1.977 0 0 0 23 14.9v.224a4.72 4.72 0 0 1-.792 2.616l-.204.306a3 3 0 0 0-.504 1.664V20a4 4 0 0 1-4 4h-4.18c-2.02 0-3.532-.768-4.848-1.576a56.445 56.445 0 0 1-.851-.535c-.981-.626-1.855-1.183-2.928-1.53C3.577 20 2.432 20 1.067 20H1a1 1 0 1 1 0-2h.179c.885 0 1.843-.002 2.821.15V13a1 1 0 1 1 2 0v5.712c1.05.435 1.976 1.028 2.804 1.558.246.157.483.31.713.45 1.212.743 2.338 1.28 3.803 1.28h4.18a2 2 0 0 0 2-2v-.289a5 5 0 0 1 .84-2.773l.204-.307c.297-.446.456-.97.456-1.506v-.224c0-.785.233-1.552.668-2.206l.049-.073A1.687 1.687 0 0 0 20.314 10H14a1 1 0 0 1-.967-1.253L14.3 3.9c.153-.583.066-1.088-.126-1.41-.173-.29-.457-.49-.925-.49a.793.793 0 0 0-.482.192z",
    fill: "#dd2e3e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.5c473526d0e1c0b4a8e7eadde739006e.svg";
export { ForwardRef as ReactComponent };